import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";

const MENU_ICON_SHAPE = "s";

const markerBaseOptions = {
    marker: MENU_ICON_SHAPE,
    fillColor: "#06535d",
    radius: 10,
    color: "#232323",
    addStroke: true,
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    lineJoin: "round",
    pane: mapOverlayPanes[4],
    interactive: false,
};

// const nm12FieldConfig = [
//     {key: "id", label: "ID"},
//     {key: "country", label: "Country"},
//     {
//         key: "area_km2",
//         label: "Area",
//         format: value => formatNumber(value, "km²"),
//     },
// ];

// const createNm12Tooltip = data => {
//     return generateTooltipHTML("12 nm", data, nm12FieldConfig, {
//         width: "400px",
//         height: "200px",
//         wrapValues: true,
//     });
// };

export const LayerLegend = createLayerLegend({
    layerName: "12 nm",
    menuIconShape: MENU_ICON_SHAPE,
    defaultMarkerOptions: markerBaseOptions,
});

// eslint-disable-next-line no-unused-vars
export function useNm12Layer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        // metadata: "MARPLAN_Datos_Batimetria_01122023_MD.XML",
        detail: false,
        // getTooltip: ({feature}) => {
        //     let data = feature.properties;
        //     return createNm12Tooltip(data);
        // },
        // // TODO next methods are necessary for map inside EntityListMap
        // // We have to design this component without repeating if is from EntityListMap or MapProvider
        // getCustomMarkerOptions: () => markerBaseOptions,
        // defaultOnClick: ({feature}) => onSelectElement(feature.id),
    });
}
